import { io } from 'socket.io-client';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.kronix.click';

let socket = null;

export function getSocket() {
  if (socket?.connected) return Promise.resolve(socket);

  const token = localStorage.getItem('token') || '';

  socket = io(API_BASE_URL, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Socket connection timeout')), 10000);
    socket.on('connect', () => { clearTimeout(timeout); resolve(socket); });
    socket.on('connect_error', (err) => { clearTimeout(timeout); reject(err); });
  });
}

export function reconnectWithToken(token) {
  if (socket) { socket.disconnect(); socket = null; }

  socket = io(API_BASE_URL, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Socket connection timeout')), 10000);
    socket.on('connect', () => { clearTimeout(timeout); resolve(socket); });
    socket.on('connect_error', (err) => { clearTimeout(timeout); reject(err); });
  });
}

export function disconnectSocket() {
  if (socket) { socket.disconnect(); socket = null; }
}

export function emit(event, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const s = await getSocket();
      s.emit(event, data || {}, (response) => {
        if (response.success) resolve(response);
        else reject(new Error(response.error || 'Request failed'));
      });
    } catch (e) {
      reject(e);
    }
  });
}
